import React from 'react';
import ImportPaymentDocumentContainer from "../containers/ImportPaymentDocumentContainer";

const ImportPaymentDocumentsPage = ({
                                        ...rest
                                    }) => {
    return (
        <>
            <ImportPaymentDocumentContainer/>
        </>
    );
};

export default ImportPaymentDocumentsPage;